<i18n>
{
  "fr": {
    "listOfProperties": "Liste des propriétés"
  }
}
</i18n>

<template>
  <b-container fluid id="app" class="c-suze">
    <router-view></router-view>
  </b-container>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
@import './styles/global.scss';
@import './styles/theme.scss';
@import url('https://unpkg.com/nprogress@0.2.0/nprogress.css');
</style>

